import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import Paper from "@limitless/modern/surfaces/paper/Paper";
import Typography from "@limitless/modern/data-display/typography/Typography";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import { usePagination, DOTS } from "./usePagination";
const useStyles = makeStyles(theme => ({
  paginationLabel: {
    cursor: "default",
    color: theme.palette.text.disabled
  },
  paginationDefaultLabel: {
    cursor: "pointer"
  },
  paginationContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    textAlign: "right",
    padding: "10px",
    background: theme.palette.background.paper,
    borderRadius: "0px 0px 8px 8px"
  },
  text: {
    // cursor: "pointer",
    display: "flex",
    textAlign: "center"
  }
}));
const Pagination = props => {
  const classes = useStyles();
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    tableRefreshFunc,
    loadMore
  } = props;
  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize
  });
  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }
  const onNext = () => {
    onPageChange(currentPage + 1);
  };
  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };
  const lastPage = paginationRange[paginationRange.length - 1];
  return /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.paginationContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    className: `${currentPage === 1 ? classes.paginationLabel : classes.paginationDefaultLabel} ${classes.text}`,
    variant: "caption",
    onClick: currentPage !== 1 ? onPrevious : null
  }, /*#__PURE__*/React.createElement(KeyboardArrowLeftOutlinedIcon, {
    sx: {
      margin: "auto",
      paddingRight: 1
    },
    fontSize: "small"
  }), /*#__PURE__*/React.createElement(Typography, {
    className: `${currentPage === 1 ? classes.paginationLabel : classes.paginationDefaultLabel} ${classes.text}`,
    sx: {
      margin: "auto"
    },
    variant: "caption"
  }, "Prev")), paginationRange.map(pageNumber => {
    if (pageNumber === DOTS) {
      return /*#__PURE__*/React.createElement(Typography, {
        key: pageNumber,
        variant: "caption",
        sx: {
          paddingLeft: "5px",
          paddingRight: "5px"
        }
      }, "\u2026");
    }
    return /*#__PURE__*/React.createElement(Typography, {
      key: pageNumber,
      variant: "caption",
      sx: {
        color: theme => pageNumber === currentPage && theme.palette.text.disabled,
        padding: "5px",
        cursor: pageNumber !== currentPage ? "pointer" : "default"
      },
      onClick: () => onPageChange(pageNumber)
    }, pageNumber);
  }), /*#__PURE__*/React.createElement(Typography, {
    className: `${currentPage === lastPage && !loadMore ? classes.paginationLabel : classes.paginationDefaultLabel} ${classes.text}`,
    variant: "caption",
    onClick: currentPage !== lastPage ? onNext : loadMore ? tableRefreshFunc : null
  }, /*#__PURE__*/React.createElement(Typography, {
    className: `${currentPage === lastPage && !loadMore ? classes.paginationLabel : classes.paginationDefaultLabel} ${classes.text}`,
    sx: {
      margin: "auto"
    },
    variant: "caption"
  }, "Next"), /*#__PURE__*/React.createElement(KeyboardArrowRightOutlinedIcon, {
    fontSize: "small",
    sx: {
      margin: "auto",
      paddingLeft: 1
    }
  }))));
};
Pagination.propTypes = {
  onPageChange: PropTypes.func,
  tableRefreshFunc: PropTypes.func,
  totalCount: PropTypes.number,
  siblingCount: PropTypes.number,
  currentPage: PropTypes.number,
  pageSize: PropTypes.number,
  loadMore: PropTypes.bool
};
export default Pagination;